import { StorefrontRounded } from '@mui/icons-material';
import BrokerQueuePage from '../components/BrokerQueuePage';
import server from '../../../services/server';

export default function AwinQueue() {
    return (
        <BrokerQueuePage
            broker="awin"
            title="Awin — fila de cadastro"
            subtitle="Sincroniza programas (anunciantes) e promoções (ofertas) via BullMQ, com limite da API de 20 req/min."
            fetchUrl="brokers/awin/queue/jobs"
            jobLabelMap={{
                programme: 'Programa',
                promotion: 'Promoção',
                'awin-sync-programme': 'Programa',
                'awin-sync-promotion': 'Promoção',
            }}
            helpItems={[
                'Worker: concorrência 1 e limiter 15 jobs/min. Programas usam programmedetails; promoções não.',
                'Cron à meia-noite enfileira programas; um gate dispara promoções quando os jobs de programa terminam.',
                'Esta lista só mostra waiting / delayed / active / paused. Histórico completo no Bull Board (/maintenance/queues).',
            ]}
            actions={[
                {
                    key: 'prog',
                    step: '1',
                    title: 'Programas',
                    description:
                        'Lista programas joined/BR na Awin e enfileira sync de anunciante + vínculo (delay escalonado ~4s).',
                    buttonLabel: 'Enfileirar programas',
                    variant: 'contained',
                    startIcon: <StorefrontRounded />,
                    request: () => server.post('brokers/awin/enqueue/programmes', {}),
                    successMessage: d =>
                        `Programas: ${d?.programmesSeen ?? '—'}. Na fila: ${d?.enqueued ?? 0}. Duplicados: ${d?.skippedDuplicates ?? 0}.`,
                },
                {
                    key: 'promo',
                    step: '2',
                    title: 'Promoções',
                    description:
                        'Página promoções ativas BR e enfileira ofertas. Prefira rodar depois dos programas (vínculos).',
                    buttonLabel: 'Enfileirar promoções',
                    variant: 'outlined',
                    request: () =>
                        server.post('brokers/awin/enqueue/promotions', { maxPages: 20, pageSize: 100 }),
                    successMessage: d =>
                        `Promoções: ${d?.promotionsSeen ?? '—'}. Na fila: ${d?.enqueued ?? 0}. Duplicados: ${d?.skippedDuplicates ?? 0}.`,
                },
            ]}
        />
    );
}
